import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "/api";

const integrationsService = {
  /* API Keys */
  listApiKeys: async () =>
    (await axios.get(`${API_URL}/admin/integrations/api-keys`)).data,

  createApiKey: async (payload) =>
    (await axios.post(`${API_URL}/admin/integrations/api-keys`, payload)).data,

  revokeApiKey: async (id) =>
    (await axios.post(`${API_URL}/admin/integrations/api-keys/${id}/revoke`)).data,

  rotateApiKey: async (id) =>
    (await axios.post(`${API_URL}/admin/integrations/api-keys/${id}/rotate`)).data,

  /* Subscriptions */
  listSubscriptions: async () =>
    (await axios.get(`${API_URL}/admin/integrations/subscriptions`)).data,

  createSubscription: async (payload) =>
    (await axios.post(`${API_URL}/admin/integrations/subscriptions`, payload)).data,

  updateSubscription: async (id, payload) =>
    (await axios.put(`${API_URL}/admin/integrations/subscriptions/${id}`, payload)).data,

  renewSubscription: async (id) =>
    (await axios.post(`${API_URL}/admin/integrations/subscriptions/${id}/renew`)).data,

  suspendSubscription: async (id) =>
    (await axios.post(`${API_URL}/admin/integrations/subscriptions/${id}/suspend`)).data,

  terminateSubscription: async (id) =>
    (await axios.post(`${API_URL}/admin/integrations/subscriptions/${id}/terminate`)).data,

  /* Conflicts */
  listConflicts: async () =>
    (await axios.get(`${API_URL}/admin/integrations/conflicts`)).data,

  resolveConflict: async (id, resolution) =>
    (await axios.post(`${API_URL}/admin/integrations/conflicts/${id}/resolve`, { resolution })).data,

  bulkResolveConflicts: async (ids, resolution) =>
    (await axios.post(`${API_URL}/admin/integrations/conflicts/bulk-resolve`, { ids, resolution })).data,

  /* Sync activity */
  listSyncBatches: async () =>
    (await axios.get(`${API_URL}/admin/integrations/sync-activity`)).data,

  getSyncBatch: async (id) =>
    (await axios.get(`${API_URL}/admin/integrations/sync-activity/${id}`)).data,

  /* Dead letter */
  listDeadLetter: async () =>
    (await axios.get(`${API_URL}/admin/integrations/dead-letter`)).data,

  dismissDeadLetter: async (id) =>
    (await axios.delete(`${API_URL}/admin/integrations/dead-letter/${id}`)).data,
};

export default integrationsService;